module.exports = __webpack_public_path__ + "img/iphone-map-NETHERLANDS-nl.bbd2c8ff.png";